import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getFileUrl } from "../../utils/helper";

const VendorSlider = ({ data = [], isLoading }) => {
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        speed: 600,
        slidesToShow: 4,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };


    return (
        <>
            {/* SHIMMER CSS */}
            <style>
                {`
          @keyframes shimmer {
            0% { background-position: -500px 0; }
            100% { background-position: 500px 0; }
          }
          .shimmer {
            background: linear-gradient(
              90deg,
              #e5e7eb 25%,
              #f3f4f6 37%,
              #e5e7eb 63%
            );
            background-size: 400px 100%;
            animation: shimmer 1.4s infinite linear;
          }
        `}
                {`
    /* GAP between slides */
    .slick-slide {
      padding: 0 10px;
    }

    /* Edge alignment fix */
    .slick-list {
      margin: 0 -10px;
    }
  `}
            </style>

            <div className="w-full   rounded-xl overflow-hidden">
                {isLoading ? (
                    /* 🔥 SHIMMER */
                    <div className="w-full h-full shimmer" />
                ) : (
                    <Slider {...settings}>
                        {data.map((item) => (
                            <div key={item._id}>
                                <img
                                    src={getFileUrl(item.image)}
                                    alt="banner"
                                    className="w-full cursor-grab rounded-xl"
                                />
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
        </>
    );
};

export default VendorSlider;
